import type { MutationHookOptions } from '@apollo/client'
import {
  RejectTrainingRequestDocument,
  RejectTrainingRequestMutation,
  RejectTrainingRequestMutationVariables,
  MyRequestsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  RejectTrainingRequestMutation,
  RejectTrainingRequestMutationVariables
>

export const useRejectTrainingRequest = (options?: Options) => {
  const [rejectTrainingRequest, { loading }] = useMutation(RejectTrainingRequestDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.rejectTrainingsTrainingRequest
  })

  return {
    loading,
    reject(variables: RejectTrainingRequestMutationVariables) {
      return rejectTrainingRequest({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          MyRequestsDataCollectionDocument,
          ...(Array.isArray(options?.refetchQueries) ? options.refetchQueries : []),
        ]
      })
    }
  }
}
